import { AfterViewInit, Directive, effect, ElementRef, inject, input, signal } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[isFocused]',
})
export class FocusDirective implements AfterViewInit {
  readonly isFocused = input(false);

  private readonly element = inject(ElementRef);

  private readonly inputElement = signal<
    HTMLInputElement | HTMLTextAreaElement | HTMLDivElement | undefined
  >(undefined);

  constructor() {
    effect(() => {
      if (!this.inputElement()) return;
      if (this.isFocused()) {
        this.inputElement()?.focus();
        return;
      }

      this.inputElement()?.blur();
    });
  }

  ngAfterViewInit(): void {
    const nativeElement = this.element.nativeElement;

    const inputElement =
      nativeElement.tagName === 'INPUT'
        ? (nativeElement as HTMLInputElement)
        : ((nativeElement as HTMLElement).querySelector('input') ?? undefined);

    const textareaElement =
      nativeElement.tagName === 'TEXTAREA'
        ? (nativeElement as HTMLTextAreaElement)
        : ((nativeElement as HTMLElement).querySelector('textarea') ?? undefined);

    const divElement =
      nativeElement.tagName === 'DIV'
        ? (nativeElement as HTMLDivElement)
        : ((nativeElement as HTMLElement).querySelector('div') ?? undefined);

    this.inputElement.set(inputElement ?? textareaElement ?? divElement);
  }
}
